import { createI18n } from 'vue-i18n'

import en from './en'
import fr from './fr'
import it from './it'

export default createI18n({
  locale: 'fr',
  legacy: false,
  fallbackLocale: 'fr',
  messages: { fr, en, it },
})
